import { store } from "@app/store";
import { addAlert } from "@features/alert/slice";

export const getFilterParamFromQuery = <T>(
  key: keyof T,
  values?: Array<T[keyof T] | null>,
  defaultValue?: T | null
) => {
  const searchParams = new URLSearchParams(window.location.search);
  let paramFromUrl: string | null | number = searchParams.get(key as string);

  if (paramFromUrl === null) {
    if (defaultValue !== undefined) return defaultValue;
    return values ? values[0] : null;
  }

  if (typeof values?.[0] === "number") {
    paramFromUrl = Number(paramFromUrl);

    if (Number.isNaN(paramFromUrl)) {
      return defaultValue ?? values[0] ?? null;
    }
  }

  return values
    ? (values.find((value) => value === paramFromUrl) ?? defaultValue ?? null)
    : (paramFromUrl as T[keyof T]);
};

export const copyToClipboard = (text: string) => {
  store.dispatch(addAlert("Сохранено в буфер обмена"));
  navigator.clipboard.writeText(text);
};

export const removeElementByIndex = (array: unknown[], index: number) => {
  if (index >= 0 && index < array.length) {
    array.splice(index, 1);
  }
  return array;
};

export const getSecureRandomInt = (min: number, max: number) => {
  const range = max - min + 1;
  const maxUint32 = 0xffffffff;
  const randomArray = new Uint32Array(1);
  window.crypto.getRandomValues(randomArray);
  return min + Math.floor((randomArray[0] / (maxUint32 + 1)) * range);
};

export const formatSeconds = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  const minStr = mins > 0 ? `${mins} мин` : "";
  const secStr = secs > 0 ? `${secs} сек` : "";
  return [minStr, secStr].filter(Boolean).join(" ");
};

export const withErrorHandling = async (
  fn: () => Promise<void>,
  onError: (message: string) => void,
  onFinally?: () => void
) => {
  try {
    await fn();
  } catch (error) {
    if (error instanceof Error) {
      onError(error.message);
    } else {
      onError("Неизвестная ошибка");
    }
  } finally {
    if (onFinally) {
      onFinally();
    }
  }
};

export function getRandomInt(min: number, max: number) {
    return Math.floor(Math.random() * (max - min)) + min;
}